<template>
	<div :class="modalMode ? 'details-in-modal page-fill' : 'pt-3 px-5 pb-2 ResponsiveStartAudit page-fill'">
        <div class="mb-2" v-if="!modalMode">
            <breadCrumbs :routesArray="routesArray"></breadCrumbs>
	    </div>
		<div class="items-center justify-between flex">
			<div class="title flex items-center" v-if="!modalMode">
				<h1>Audit</h1>
			</div>
			<div v-else></div>
			<div class="flex items-center">
                <div class="flex parent-toggle-border border rounded-sm border-lightgrey bg-white">
                <button :class="{ 'active-tab': activeButton === 'myControls', 'inactive-tab': activeButton !== 'myControls' }" class="flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-8 text-xs" @click="showMyControls">
                    My Controls
                </button>
                <button :class="{ 'active-tab': activeButton === 'allControls', 'inactive-tab': activeButton !== 'allControls' }" class="flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-8 text-xs" @click="showAllControls">
                    All Controls
                </button>
            </div>
            <!-- <button class="btnprimary ml-3 hidden items-center" @click="showAddControlPopup()">
                <img src="@/assets/plusIcon.svg" class="filterIcon" />
                Add
            </button> -->
            <button class="ml-3 flex" @click="filterOpen" :class="tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'">
                <img v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
                <img v-else src="@/assets/filter.svg" class="filterIcon" />
                Filters
            </button>
			</div>
		</div>
		<div class="mt-6">
			<p class="headerText">
				This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you
				to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security.
			</p>
		</div>
        <div class="mt-4 table-section">
        <div class="table-data-root">
        <div class="table-card-shell tableCornerRadius bg-white">
            <div class="table-card-inner">
            <div class="table-container table-container-fit">
                <div class="table-header-wrap">
                <table class="main-table table-fit-card table-header-table" :style="tableResizeStyle">
                <colgroup>
                    <col v-for="column in columnNames" :key="'h-'+column" :style="columnStyle(column)" />
                </colgroup>
                <thead>
                    <tr class="table-header-row">
                    <th scope="col" v-for="column in columnNames" :key="column" class="bg-white th1 cursor-pointer capitalize resizable-th" :class="getColumnHeadWidth(column)" :style="columnStyle(column)" @click="onHeaderClick(column)" @mouseout="doFalse()">
                        <div class="flex table-header-label-wrap">
                            <div class="table-header-label" @mousemove="headerToolTip(column, $event)">
                            <div v-if="column == 'controlNumber'">
                                <div>{{ 'Control' }}</div>
                            </div>
                            <div v-else-if="column == 'controlName'">
                                <div>{{ 'Title' }}</div>
                            </div>
                                <div v-else-if="column == 'team'">
                                <div>{{ 'Team' }}</div>
                            </div> <div v-else-if="column == 'entity'">
                                <div>{{ 'Location' }}</div>
                            </div>
                            
                            <div v-else class="">{{ column }}</div>
                            </div>
                            <div v-if="!isColumnFrameWork(column)" class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>
                        </div>
                        <span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, column)"></span>
                        <div v-if="pop == true && tipColumn == column && tipIndex == 'header'">
                            <tool-tip :columnName="column" :tipText="tipText" :styling="styling"></tool-tip>
                        </div>
                    </th>
                    </tr>
                    <tr v-if="showFilters" class="table-filter-row">
                        <td v-for="name in columnNames" class="bg-white" :key="name" :class="getColumnHeadWidth(name)" :style="columnStyle(name)">
                            <div v-if="isColumnFrameWork(name)"></div>
                            <input v-else type="text" class="searchForInputBoxStyling w-28" placeholder="Search" v-model.trim="filterDummy[name]" />
                        </td>
                    </tr>
                </thead>
                </table>
                </div>
                <div class="table-body-scroll">
                <table class="main-table table-fit-card" :style="tableResizeStyle">
                <colgroup>
                    <col v-for="column in columnNames" :key="'b-'+column" :style="columnStyle(column)" />
                </colgroup>
                <tbody v-if="dataLoading == true">
                    <tr class="cursor-pointer empty rowHeight">
                        <td class="relative h-5" :colspan="columnNames.size">
                            <div class="flex items-center justify-center w-full h-16 skeleton">
                                <dots-loader/>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else-if="sortedData.length == 0">
                    <tr class="cursor-pointer rowHeight">
                        <td class="relative h-10" :colspan="columnNames.size">
                            <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else class="nonEmptyTable">
                    <tr v-for="(row, index) in sortedData" :key="index" class="rowHeight">
                        <td v-for="presentColumn in columnNames" :key="presentColumn" @mouseout="doFalse()" class="cursor-pointer relative" :class="getColumnHeadWidth(presentColumn)" :style="columnStyle(presentColumn)">
                            <div class="h-full w-32 flex items-center" v-if="isColumnFrameWork(presentColumn)">
                                <div class="h-full w-full flex flex-wrap items-center" v-if="row[presentColumn].length>0" >
                                    <div v-for="ctrlNumber in row[presentColumn]" @click="clickedOnFrameWorkControlNumber(ctrlNumber,presentColumn)" :key="ctrlNumber" :class="getBorder()" class="text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto flex items-center" >
                                        {{ctrlNumber}}
                                    </div>
                                </div>
                                <div class="" v-else>
                                    {{'N/A'}}
                                </div>
                            </div>
                            <!-- <div v-else-if="presentColumn == 'team'"><p class="cursor-pointer text-xs">{{ getTeamName(row[presentColumn]) }}</p></div> -->
                            <!-- <div v-else-if="presentColumn == 'entity'"><p class="cursor-pointer text-xs">{{ getLocationName(row[presentColumn]) }}</p></div> -->
                            <div v-else>
                                <div class="table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
                                    {{ row[presentColumn] }}
                                </div>
                                <div v-if="pop == true && tipColumn == presentColumn && tipIndex == index">
                                    <tool-tip :columnName="presentColumn" :tipText="tipText" :styling="styling"></tool-tip>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                </table>
                </div>
            </div>
            <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData"></pagination>
            </div>
            </div>
            </div>
        </div>

        <popup v-if="addControlPopup" :popUp="addControlPopup">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>New Control</h1>

                    <button class="float-right text-3xl" @click="onCloseAddPopup()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>

            <div class="popup-business">
                <div>
                    <div>
                        <div class="statuscontainer popupbodycontainer">
                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full mt-3">
                                    <div class="w-1/2 px-2">
                                        <label for="number" class="controllabel">Control Number</label><br />
                                        <input class="inputboxstyling" placeholder="Control Number" :value="controlAddObject.controlNumber" />
                                    </div>
                                    <div class="w-1/2 px-2">
                                        <label for="number" class="controllabel">Title</label><br />
                                        <input class="inputboxstyling" placeholder="Title" :value="controlAddObject.controlTitle" />
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full mt-3">
                                    <div class="w-1/2 px-2">
                                        <label for="number" class="controllabel">Team</label><br />
                                        <select
                                            class="inputboxstyling"
                                            v-model="controlAddObject.team"
                                        >
                                            <option value='' selected disabled hidden>Please select one</option>

                                            <option v-for="option in teamObject" :key="option" :value="option.value">
                                                {{ option.label }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="w-1/2 px-2">
                                        <label for="number" class="controllabel">Location</label><br />
                                        <select
                                            class="inputboxstyling"
                                            v-model="controlAddObject.entity"
                                        >
                                            <option value='' selected disabled hidden>Please select one</option>

                                            <option v-for="option in locationObject" :key="option" :value="option.value">
                                                {{ option.label }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </popup>

        <popup v-if="viewControlNumberPopup" :popUp="viewControlNumberPopup">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>{{frameWorkControlNumberObject.selectedFrameWork}}</h1>

                    <button class="float-right text-3xl" @click="onCloseFrameWorkControl()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>

            <div class="popup-business">
                <div>
                    <div>
                        <div class="statuscontainer popupbodycontainer">
                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full mt-3">
                                    <div class="w-full px-1">
                                        <label for="number" class="controllabel">Frame Work No:</label><br />
                                        <div :class="getBorder()" class="text-xs mt-2 mb-3 px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center">{{frameWorkControlNumberObject.controlNumber}}</div>
                                        <!-- <input class="inputboxstyling" placeholder="Frame Work Number" :value="frameWorkControlNumberObject.controlNumber" /> -->
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full">
                                    <div class="w-full px-1">
                                        <label for="number" class="controllabel">Title</label><br />
                                        <div class="text-sm mt-2 mb-3">{{frameWorkControlNumberObject.controlTitle}}</div>
                                        <!-- <input class="inputboxstyling" placeholder="Title" :value="frameWorkControlNumberObject.controlTitle" /> -->
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full">
                                    <div class="w-full px-1">
                                        <label for="number" class="controllabel">Description</label><br />
                                        <div class="text-sm mt-2 mb-3">{{frameWorkControlNumberObject.description}}</div>
                                        <!-- <textarea
                                            class="inputboxstyling"
                                            placeholder="Threat"
                                            v-model="frameWorkControlNumberObject.description"
                                        /> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </popup>
	</div>
</template>
<style scoped>
.popup-business {
    overflow-y: scroll;
}
::-webkit-scrollbar {
    width: 0px;
}

/* .rowHeight {
	height: 100px;
} */
th,td{
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   min-width: 0;
   text-align: left;
   vertical-align: middle;
}
.numberBorder{
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
}
.numberNavy{
    border-left: 1px solid #152A43;
    border-width: 2px;
}
.active-tab {
    background-color: #1976d2;
    color: white;
}
.active-tab, .inactive-tab {
    transition: background-color 0.4s ease, color 0.4s ease;
}
.inactive-tab {
    color: black;
    fill: #1976d2 !important;
}
.nonEmptyTable:last-child  {
	border-bottom: 1px solid #e9e9e9;
}
.table-ellipsis {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
	overflow-wrap: normal;
	max-width: 100%;
}
.emptyRowAdjustment{
    padding-left : 47%;
}

</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { required } from '@vuelidate/validators';
import tableData from '@/components/tableData.vue';
import { mapGetters } from 'vuex';
import { emitter, toast } from '@/main';
import { groupBy } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import pagination from '@/components/pagination.vue';
import popup from '@/components/popup.vue';
import toolTip from '@/components/toolTip.vue';
import breadCrumbs from '@/components/breadCrumbs.vue'
import dotsLoader from '@/components/dotsLoader.vue';
import { columnResizeMixin } from '@/mixins/columnResizeMixin';

export default defineComponent({
	mixins: [columnResizeMixin],
	data(): any {
		return {
			showFilters: false,
            allFrameWorkControls:[],
            orgFrameWorks:[],
            presentAuditFrameWorks:[],
            tableRow:[],
            mainHeaders:[],
            filterDummy: {},
			classSort: '',
			className: '',
			dummyList:[],

			pageType: '',

			currentSort: 'name',
			currentSortDir: 'asc',

			currentPage: '',
			pageSize:'',
			dynamicPagination: '',
            teamObject:[],
            locationObject:[],
            pop: false,
			styling: { left: '', bottom: '' },
			tipText: '',
			tipColumn: '',
			tipIndex: '',
            activeButton:'',
            addControlPopup:false,
            controlAddObject:{
                controlNumber:'',
                controlTitle:'',
                team:'',
                entity:'',
            },
            teamsData:[],
            viewControlNumberPopup:false,
            frameWorkControlNumberObject:{},
            routesArray: [],
            presentAudit:{},
            internalControlsDetailsArray:[],
            mainAuditControls:[],

            rootInternalControlsArray:[],
            dataLoading:true,

		};
	},
	components: {
        pagination,
        popup,
        toolTip,
        breadCrumbs,
        dotsLoader
	},
	props: {
		auditId: { type: [String, Number], default: null },
		modalMode: { type: Boolean, default: false },
	},
	emits: ['header-info', 'open-nested'],
	computed: {
		...mapGetters({ userInfo: 'userInfo' }),
		currentAuditId(): any {
			return this.auditId || this.currentAuditId;
		},
        sortedData: function (): any {
			return [...this.tableRow]
				.filter((row: any, index: any) => {
					for (const key in this.filterDummy) {
						const inputValue = this.filterDummy[key];
						if (inputValue !== '' && row[key]) {
							if (Number.isInteger(row[key])) {
								if (row[key] !== Number(inputValue)) {
									return false;
								}
							} else {
								if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
									return false;
								}
							}
						}
					}
					return true;
				})
				.sort((a, b) => {
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				})
				.filter((row, index) => {
					this.dynamicPagination = index + 1;
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
		},
        columnNames: function (): any {
			const names = new Set();
			for (const key of this.mainHeaders) {
				names.add(key);
			}
			return names;
		}
	},
	// async mounted() {
	// },
	methods: {
		getResizeColumnNames(): string[] {
			return Array.from(this.columnNames || []);
		},
        getColumnHeadWidth(column: any) {
            if (column == 'controlName') {
                return 'titleColumnWidth';
            } else if( column == 'controlNumber'){
                return 'w-32';
            }else if( column == 'team' || column == 'entity'){
                return 'w-32';
            }else {
                return 'w-32';
            }
        },
        isColumnFrameWork(presentColumn:any){
            if(this.presentAuditFrameWorks.includes(presentColumn)){
                return true
            }else{
                return false
            }
        },
        clickedOnFrameWorkControlNumber(ctrlNum:any,frameWork:any){
            let findObj:any = this.allFrameWorkControls.find((obj:any)=>{return obj.controlNumber == ctrlNum && obj.controlFrameWork ==  frameWork})
            this.frameWorkControlNumberObject.selectedFrameWork = frameWork;
            this.frameWorkControlNumberObject.controlNumber = ctrlNum;
            if(findObj!= undefined){
                this.frameWorkControlNumberObject.controlTitle = findObj.controlTitle;
                this.frameWorkControlNumberObject.description = findObj.controlAuditMethodology
            }
            this.viewControlNumberPopup = true;
        },
        onCloseFrameWorkControl(){
            this.viewControlNumberPopup = false;
        },
        showAddControlPopup(){
            this.addControlPopup = true
        },
        onCloseAddPopup(){
            this.addControlPopup = false
            Object.keys(this.controlAddObject).forEach((prop) => {
				Array.isArray(this.controlAddObject[prop]) ? (this.controlAddObject[prop] = []) : (this.controlAddObject[prop] = '');				
			});
        },
        showMyControls(){
            this.activeButton = 'myControls'
        },
        showAllControls(){
            this.activeButton = 'allControls'
        },
        getBorder(){
            return `numberBorder numberNavy`
        },
        toolTip(column: any, e: any, index: any, row: any, status: any) {
			this.tipText = (e.currentTarget?.textContent || row[column] || '').toString().trim();
			this.tipColumn = column;
			this.tipIndex = index;

			switch (status) {
				case 'text':
					this.handleTextTooltip(e);
					break;
			}
		},
		headerToolTip(column: any, e: any) {
			const container = e.currentTarget;
			const label = (container?.textContent || '').toString().trim();
			if (label && container && this.isTextOverflowed(container)) {
				this.pop = true;
				this.tipText = label;
				this.tipColumn = column;
				this.tipIndex = 'header';
				this.styling.left = e.offsetX + 38 + 'px';
				this.styling.bottom = -45 + 'px';
			} else {
				this.pop = false;
			}
		},
		handleTextTooltip(e: any) {
			const container = e.currentTarget.classList?.contains('table-ellipsis')
				? e.currentTarget
				: e.currentTarget.closest('.table-ellipsis');
			if (container && this.isTextOverflowed(container)) {
				this.pop = true;
				this.styling.left = e.offsetX + 38 + 'px';
				this.styling.bottom = -45 + 'px';
			} else {
				this.pop = false;
			}
		},
		isTextOverflowed(element: any) {
			return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
		},
		doFalse() {
			this.pop = false;
		},
        sort(tableHead: any) {
			this.className = tableHead;
			if (tableHead == this.currentSort) {
				this.currentSortDir = this.currentSortDir == 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = tableHead;
			this.classSort = this.currentSortDir == 'asc' ? 'sort_asc' : 'sort_desc';
		},
		paginationUpdations(currentPage: any, pageSize: any) {
			this.currentPage = currentPage;
			this.pageSize = pageSize;
		},
		filterOpen() {
			this.showFilters = !this.showFilters;
			emitter.emit('visible', this.showFilters);
            this.filterDummy = {}
		},
        getTeamName(ownerId: any) {
            let user = this.teamObject.find((obj: any) => {
                return obj.value == ownerId;
            });
            if (user == undefined) {
                let empty = '';
                return empty;
            } else {
                return user.label;
            }
        },
		 getLocationName(locationId: any) {
            let locationObj = this.locationObject.find((obj: any) => {
                return obj.value == locationId;
            });
            if (locationObj == undefined) {
                let empty = 'N/A';
                return empty;
            } else {
                return locationObj.label;
            }
        },
        async getAllControls(){
            await this.$http
				.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls`)
				.then((result: { data: any }) => {
                    this.allFrameWorkControls = result.data;
				})
				.catch((error: any) => {
                    toast.error(` ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
				});
        },
        async getAllTeams() {
            this.teamObject = []
            let users:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                users = res.data;
                this.teamsData = res.data;
            });
            for (var i = 0; i < users.length; i++) {
                this.teamObject.push({ label: users[i].displayName, value: users[i]._id });
            }
        },
		 async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id ,entityType:result[i].entityType});
            }
        },
        async getPresentAudit(){
			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audits/getAll`).then((result: any) => {
				// this.existingAuditsArray = [...result.data];
                this.presentAudit = result.data.find((obj:any)=>{
                   return  obj._id == this.currentAuditId;
                })
               this.presentAuditFrameWorks =  [...this.presentAudit.frameworks]
               if (this.modalMode && this.presentAudit?.title) {
                    this.$emit('header-info', { title: this.presentAudit.title || 'Audit Controls' });
               }
			})
		},
        async startSelectedAudit(cameId:any){
			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audit/${cameId}/startAudit`).then((result: any) => {
                this.internalControlsDetailsArray = [...result.data];
			})
		},

        async getDetailsForTable(){

            this.tableRow = []
            this.internalControlsDetailsArray.map((teamControlsObject:any,mainIndex:any)=>{

                let presentLocation:any
                
                let presentteamObject:any = this.teamsData.find((obj: any) => {
                    return obj._id == teamControlsObject.departmentsAndEntities[0].department;
                });

                if (presentteamObject != undefined && presentteamObject.entityType == 20301){
                    presentLocation = this.locationObject.find((l:any)=>l.entityType==1)?.label;
                }else if(presentteamObject != undefined && presentteamObject.entityType == 20303){
                    // presentLocation = this.getLocationName(presentteamObject.entityId)
                    presentLocation = presentteamObject.entityDisplayName
                }

                teamControlsObject['controls'].map(async (activeControlObject:any,index:any)=>{
                    
                    let sendObject:any = { 
                        _id:activeControlObject._id ,
                        "controlNumber": activeControlObject.controlNumber != undefined ? activeControlObject.controlNumber : 'N/A', 
                        "controlName": activeControlObject.controlTitle != undefined ?  activeControlObject.controlTitle : 'N/A',
                        "team": presentteamObject.displayName != undefined ? presentteamObject.displayName : 'N/A',
                        "entity": presentLocation != undefined ? presentLocation : 'N/A',
                        "auditStatus": 10401
                    };

                    let rootControl:any = await this.getRootIc(activeControlObject.rootFrameWork)


                    this.presentAuditFrameWorks.map((key:any)=>{
                        sendObject[key] = [];
                        if(Object.keys(activeControlObject).includes('frameworks')){
                            let frameWorkObj = activeControlObject.frameworks.find((obj:any)=>{return obj.framework == key|| obj.frameWork == key});
                            if(frameWorkObj != undefined){
                                sendObject[key] = frameWorkObj.controls
                            }else{
                                return 'N/A'
                            }
                        }
                    })

                    this.tableRow.push(sendObject)
                })
            })
        },

        async getRootIc(id:any){
            let a:any = this.rootInternalControlsArray.find((obj:any)=>{return obj._id == id});

            if(a!= null && a != undefined){
                return a
            }
        },

        async getRootInternalControls(){
            await this.$http
				.get(`${process.env.VUE_APP_CONTROLS_API}/api/root/frameWorkcontrols/getall?frameWork=${'InternalControls'}`)
				.then((result: { data: any }) => {
					this.rootInternalControlsArray = result.data
				})
				.catch((error: any) => {
					// console.log('error',error)
				});
        }
	},
    
	async created() {

        this.dataLoading = true;

        await this.getPresentAudit();
        let headersData = ['controlNumber','controlName','team','entity',...this.presentAuditFrameWorks]
        this.mainHeaders = headersData;

        await this.startSelectedAudit(this.presentAudit._id)
        this.routesArray = [
			{ name: 'Audit', routeName: 'audit' },
            { name: `${this.presentAudit.title} - Controls`, routeName: 'audit-controls' },
		];

        this.showMyControls()
        await this.getAllTeams();
        await this.getallEntities();
        await this.getAllControls();

        await this.getRootInternalControls();

        await this.getDetailsForTable();

        this.dataLoading = false;
	}
});
</script>
